<template>
  <el-dialog
    title="消息详情"
    width="480px"
    :close-on-click-modal="true"
    :visible.sync="visible"
    append-to-body>
    <el-tabs type="border-card" class="el-tab">
    <el-form class="form-modal" :model="dataForm" ref="dataForm"
             @keyup.enter.native="dataFormSubmit()" label-width="88px">
    <el-form-item label="消息主题">
      <el-input v-model="dataForm.msgTopic" placeholder="消息主题" class="common-width" :disabled="true"></el-input>
    </el-form-item>
    <el-form-item label="消息内容">
      <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 8}" v-model="dataForm.msgBody" placeholder="消息内容" class="common-width" :disabled="true"></el-input>
    </el-form-item>
    <el-form-item label="发布用户">
      <el-input v-model="dataForm.userName" placeholder="发布用户" class="common-width" :disabled="true"></el-input>
    </el-form-item>
    <el-form-item label="阅读时间" v-if="dataForm.read">
      <el-input v-model="dataForm.readTime" placeholder="阅读时间" class="common-width" :disabled="true"></el-input>
    </el-form-item>
    <el-form-item label="阅读回复">
      <el-input v-model="dataForm.readRemark" placeholder="已读回复" maxlength="49" class="common-width" :disabled="dataForm.read"></el-input>
    </el-form-item>
    </el-form>
    </el-tabs>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button type="warning" v-if="hasJumpPermission" @click="pushRouterHandle()">菜单跳转</el-button>
      <el-button type="primary" v-if="dataForm.read" @click="readCancelHandle()">恢复未读</el-button>
      <el-button type="primary" v-if="!dataForm.read" @click="readMsgHandle()">标记已读</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        dynamicMenuRoutes: [],
        dataForm: {
          id: 0,
          url: '',
          msgTopic: '',
          msgBody: '',
          userName: '',
          read: false,
          readTime: '',
          readRemark: '',
        }
      }
    },
    computed: {
      // 判断是否有菜单跳转权限
      hasJumpPermission() {
        if (!this.dataForm.url) return false; // 没有url则不显示
        const urlPtah = this.dataForm.url.replace('/', '-');
        // 检查动态路由中是否存在对应权限
        return this.dynamicMenuRoutes.some(item => item.name === urlPtah);
      }
    },
    created() {
      this.dynamicMenuRoutes = JSON.parse(sessionStorage.getItem('dynamicMenuRoutes') || '[]')
    },
    methods: {
      init (row) {
        this.dataForm.id = row.id
        this.dataForm.url = row.url
        this.dataForm.msgTopic = row.msgTopic
        this.dataForm.msgBody = row.msgBody
        this.dataForm.userName = row.userName
        this.dataForm.read = row.read
        this.dataForm.readTime = row.readTime
        this.dataForm.readRemark = row.readRemark
        this.visible = true
      },
      // 菜单跳转
      pushRouterHandle () {
        if (this.dataForm.url != undefined && this.dataForm.url.length > 0) {
          let urlPtah = this.dataForm.url.replace('/','-')
          if (this.$store.state.common.mainTabsActiveName != urlPtah) {
            var route = this.dynamicMenuRoutes.filter(item => item.name === urlPtah)
            if (route.length >= 1) {
              console.log("notice push url : " + urlPtah);
              this.$router.push({ name: route[0].name })
            } else {
              this.$message({
                message: '没有待跳转的菜单权限',
                type: 'warning',
                duration: 1000
              });
            }
          }
        }
        this.visible = false
      },
      // 恢复未读
      readCancelHandle () {
        this.$http({
          url: this.$http.adornUrl('/message/notice/read/cancel'),
          method: 'post',
          data: this.$http.adornData(this.dataForm.id,false)
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      // 已读提交
      readMsgHandle () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: this.$http.adornUrl('/message/notice/read/text'),
              method: 'post',
              data: this.$http.adornData({
                id: this.dataForm.id,
                remark: this.dataForm.readRemark
              })
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      },
      msgTypeSelected(index,value) {
        this.dataForm.msgBody = value.construct
        this.dataForm.autFlag = value.autFlag
        this.dataForm.msgTopic = this.formatValue(value.kind, 'msgKind')+'-'+value.name
        this.dataForm.autBanks = value.autBanks!=undefined?value.autBanks.split(","):[]
        this.dataForm.autUsers = value.autUsers!=undefined?value.autUsers.split(","):[]
        this.dataForm.autRoles = value.autRoles!=undefined?value.autRoles.split(","):[]
      },
      autFlagChange(value) {
        this.dataForm.autBanks = [];
        this.dataForm.autUsers = [];
        this.dataForm.autRoles = [];
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/noticeDrawer/notice-view.vue